// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sIkaZWcl7xNJD_QyKybh{margin:0;padding:0}.YhqVNdFw0WJn0x2SHp7g{list-style:none;margin:0;padding:0}.YhqVNdFw0WJn0x2SHp7g:last-of-type div [data-star=true]{border-radius:0 0 0 5px}[dir=rtl] .YhqVNdFw0WJn0x2SHp7g:last-of-type div [data-star=true]{border-radius:0 0 5px 0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `sIkaZWcl7xNJD_QyKybh`,
	"item": `YhqVNdFw0WJn0x2SHp7g`
};
module.exports = ___CSS_LOADER_EXPORT___;
